import { useState } from "react";

import { Button } from "src/@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger
} from "src/@/components/ui/dropdown-menu";

import { loadLocale, locales } from "./utils";

export function LanguageSelector() {
  const [currentLocale, setCurrentLocale] = useState<string>(
    localStorage.getItem("locale") || "en"
  );

  const handleLanguageChange = async (newLocale: string) => {
    localStorage.setItem("locale", newLocale);
    await loadLocale(newLocale);
    setCurrentLocale(newLocale);
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm">
          {currentLocale.toUpperCase()}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {Object.entries(locales).map(([value, label]) => (
          <DropdownMenuItem key={value} onClick={async () => await handleLanguageChange(value)}>
            {label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
} 
